import { ImgID } from "../image_loader/img_id.js";

export class AvatarUtils {
  // Reserved avatar id meaning "use the player's Facebook photo".
  // The real photo is loaded by URL (see facebook_avatar_loader); getAvatarImgId
  // returns a placeholder ImgID used until/if the remote photo is available.
  public static readonly FACEBOOK_AVATAR_ID = 987;

  public static getAvatarImgId( avatar_id: number ): ImgID
  {
    if ( avatar_id === AvatarUtils.FACEBOOK_AVATAR_ID )
      return ImgID.FacebookIcon;

    const ids = [
      ImgID.Avatar_0,  ImgID.Avatar_1,  ImgID.Avatar_2,  ImgID.Avatar_3,  ImgID.Avatar_4,
      ImgID.Avatar_5,  ImgID.Avatar_6,  ImgID.Avatar_7,  ImgID.Avatar_8,  ImgID.Avatar_9,
      ImgID.Avatar_10, ImgID.Avatar_11, ImgID.Avatar_12, ImgID.Avatar_13, ImgID.Avatar_14,
      ImgID.Avatar_15, ImgID.Avatar_16, ImgID.Avatar_17, ImgID.Avatar_18, ImgID.Avatar_19,
    ];

    if ( avatar_id >= 0 && avatar_id < ids.length )
      return ids[avatar_id];

    return ImgID.Avatar_0;
  }
}
